// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"328":"admin","343":"onboarding","674":"iso","710":"merchant","983":"payments"}[chunkId] + "." + {"328":"a3d562a0","343":"7012a830","674":"9c7ced24","710":"60a47be8","983":"fc78df7c"}[chunkId] + ".css";
};